import React from 'react';
import { Skeleton } from '@mui/material';
import styles from './UncategorizedFlowsCard.module.scss';

const UncategorizedFlowsSkeleton = () => {
  return (
    <div className={styles.cardContainer}>
      <div className={styles.cardContent}>
        <div className={styles.leftSection}>
          <div className={styles.warningIcon}>
            <Skeleton variant="circular" width={24} height={24} />
          </div>
          <div className={styles.contentArea}>
            <div className={styles.titleRow}>
              <Skeleton
                variant="rounded"
                width={180}
                height={24}
                style={{ marginBottom: 'var(--spacing-md)' }}
              />

              <Skeleton
                variant="rounded"
                width={140}
                height={24}
                style={{ borderRadius: '12px' }}
              />
            </div>
            <Skeleton
              variant="rounded"
              width="90%"
              height={16}
              style={{ marginBottom: 'var(--spacing-sm)' }}
            />
          </div>
        </div>

        <div className={styles.rightSection}>
          <div className={styles.statsContent}>
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton variant="rounded" width={24} height={20} />
            <Skeleton variant="rounded" width={70} height={16} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UncategorizedFlowsSkeleton;
